var _path, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadGooglePlay = function SvgDownloadGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 40,
    viewBox: "0 0 134 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C2.687 0 0 2.686 0 6V34C0 37.313 2.687 40 6 40H128C131.313 40 134 37.313 134 34V6C134 2.686 131.313 0 128 0H6Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 40
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C2.687 0 0 2.686 0 6V34C0 37.313 2.687 40 6 40H128C131.313 40 134 37.313 134 34V6C134 2.686 131.313 0 128 0H6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7 12.2C47.2 11.7 47.4 11 47.4 10.2V9.9H44.5V10.6H46.7C46.7 11.1 46.5 11.5 46.2 11.8C45.7 12.3 45.2 12.5 44.5 12.5C43.9 12.5 43.4 12.2 42.9 11.8C42.4 11.4 42.2 10.8 42.2 10.1C42.2 9.4 42.4 8.8 42.9 8.4C43.3 7.9 43.9 7.7 44.5 7.7C45.2 7.7 45.7 7.9 46.1 8.4L46.6 7.9C46.4 7.6 46.1 7.4 45.7 7.2C45.3 7 44.9 6.9 44.5 6.9C43.6 6.9 42.9 7.2 42.3 7.8C41.7 8.4 41.4 9.1 41.4 10C41.4 10.9 41.7 11.6 42.3 12.2C42.9 12.8 43.6 13.1 44.5 13.1C45.4 13.1 46.1 12.8 46.7 12.2ZM49.3 7.7H52V7H48.5V13H52V12.2H49.3V10.3H51.8V9.6H49.3V7.7ZM55.3 13H54.5V7.7H52.8V7H57V7.7H55.3V13ZM60.7 7H59.9V13H60.7V7ZM64 13H63.3V7.7H61.6V7H65.7V7.7H64V13ZM71.4 13.1C72.3 13.1 73 12.8 73.6 12.2C74.2 11.6 74.5 10.9 74.5 10C74.5 9.1 74.2 8.4 73.6 7.8C73 7.2 72.3 6.9 71.4 6.9C70.5 6.9 69.8 7.2 69.2 7.8C68.6 8.4 68.3 9.1 68.3 10C68.3 10.9 68.6 11.6 69.2 12.2C69.8 12.8 70.5 13.1 71.4 13.1ZM69.8 11.7C70.2 12.1 70.8 12.4 71.4 12.4C72 12.4 72.6 12.2 73 11.7C73.4 11.3 73.7 10.7 73.7 10C73.7 9.3 73.5 8.7 73 8.3C72.6 7.9 72 7.6 71.4 7.6C70.8 7.6 70.2 7.8 69.8 8.3C69.4 8.7 69.1 9.3 69.1 10C69.1 10.7 69.3 11.3 69.8 11.7ZM76.5 7H75.6V13H76.3V9.3V8.1L79.4 13H80.2V7H79.4V10.5V11.7L76.5 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7 23.1V24.9H52C51.9 25.9 51.5 26.7 51 27.2C50.4 27.8 49.4 28.5 47.7 28.5C45 28.5 43 26.4 43 23.7C43 21 45.1 18.9 47.7 18.9C49.1 18.9 50.2 19.5 51 20.2L52.3 18.9C51.2 17.9 49.8 17.1 47.8 17.1C44.2 17.1 41.1 20.1 41.1 23.7C41.1 27.3 44.2 30.3 47.8 30.3C49.8 30.3 51.2 29.7 52.4 28.4C53.6 27.2 54 25.5 54 24.2V24.2C54 23.8 54 23.4 53.9 23.1H47.7ZM58.8 21.8C56.4 21.8 54.5 23.6 54.5 26.1C54.5 28.5 56.4 30.4 58.8 30.4C61.2 30.4 63.1 28.6 63.1 26.1C63.1 23.5 61.2 21.8 58.8 21.8ZM63.8 26.1C63.8 23.6 65.7 21.8 68.1 21.8C70.5 21.8 72.4 23.5 72.4 26.1C72.4 28.6 70.5 30.4 68.1 30.4C65.7 30.4 63.8 28.5 63.8 26.1ZM65.7 26C65.7 27.5 66.8 28.6 68.1 28.6C69.4 28.6 70.5 27.5 70.5 26C70.5 24.4 69.4 23.4 68.1 23.4C66.8 23.4 65.7 24.5 65.7 26ZM56.4 26C56.4 27.5 57.5 28.6 58.8 28.6C60.1 28.6 61.2 27.5 61.2 26C61.2 24.4 60.1 23.4 58.8 23.4C57.5 23.4 56.4 24.5 56.4 26ZM89.5 21.8C91.7 21.8 92.7 23.5 93.1 24.5L93.3 25L87.6 27.4C88.1 28.3 88.7 28.7 89.7 28.7C90.7 28.7 91.3 28.2 91.8 27.5L93.2 28.5C92.8 29.2 91.6 30.4 89.7 30.4C87.3 30.4 85.5 28.5 85.5 26.1C85.5 23.5 87.3 21.8 89.5 21.8ZM87.3 25.9C87.3 24.3 88.6 23.4 89.5 23.4C90.2 23.4 90.9 23.8 91.1 24.3L87.3 25.9ZM84.5 30H82.6V17.5H84.5V30ZM79.6 22.7C79.1 22.2 78.3 21.7 77.3 21.7C75.2 21.7 73.2 23.6 73.2 26C73.2 28.4 75.1 30.2 77.3 30.2C78.3 30.2 79.1 29.7 79.5 29.2H79.6V29.8C79.6 31.4 78.7 32.3 77.3 32.3C76.2 32.3 75.4 31.5 75.2 30.8L73.6 31.5C74.1 32.6 75.3 34 77.4 34C79.6 34 81.4 32.7 81.4 29.6V22H79.6V22.7ZM75 26C75 27.5 76.1 28.6 77.4 28.6C78.7 28.6 79.7 27.5 79.7 26C79.7 24.5 78.7 23.4 77.4 23.4C76.1 23.4 75 24.5 75 26ZM101.8 17.5H97.3V30H99.2V25.3H101.8C103.9 25.3 105.9 23.8 105.9 21.4C105.9 19 103.9 17.5 101.8 17.5ZM99.2 23.5H101.9C103.2 23.5 104 22.4 104.1 21.3C104.1 20.4 103.3 19.2 101.9 19.2H99.2V23.5ZM113.4 21.7C112 21.7 110.6 22.3 110.1 23.6L111.8 24.3C112.2 23.6 112.8 23.4 113.5 23.4C114.5 23.4 115.4 24 115.5 25V25.1C115.2 24.9 114.4 24.6 113.6 24.6C111.8 24.6 110 25.6 110 27.4C110 29.1 111.5 30.2 113.1 30.2C114.4 30.2 115 29.6 115.5 29H115.6V30H117.4V25.2C117.2 23 115.5 21.7 113.4 21.7ZM111.7 27.5C111.7 28.3 112.6 28.6 113.2 28.6C114.2 28.6 115.2 27.8 115.4 26.6C115.349 26.5798 115.3 26.5596 115.251 26.5396C114.815 26.3616 114.419 26.2 113.7 26.2C112.8 26.2 111.7 26.5 111.7 27.5ZM123.7 22L121.6 27.4H121.5L119.3 22H117.3L120.6 29.6L118.7 33.8H120.6L125.7 22H123.7ZM108.8 30H106.9V17.5H108.8V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52319 7.50001C9.22319 7.80001 9.02319 8.30001 9.02319 8.90001V31C9.02319 31.6 9.22319 32.1 9.52319 32.4L9.62319 32.5L22.0232 20.1V20V19.9L9.52319 7.50001Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1232 24.3L22.0232 20.2V20V19.9L26.1232 15.8L26.2232 15.9L31.1232 18.7C32.5232 19.5 32.5232 20.8 31.1232 21.6L26.1232 24.3Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2232 24.2L22.0232 20L9.52319 32.5C10.0232 33 10.7232 33 11.6232 32.6L26.2232 24.2Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2232 15.8L11.6232 7.50001C10.7232 7.00001 10.0232 7.10001 9.52319 7.60001L22.0232 20L26.2232 15.8Z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.5595,
    y1: -7.42721,
    x2: -3.30824,
    y2: -2.05499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 32.9576,
    y1: 9.8697,
    x2: 8.76069,
    y2: 9.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9.20595,
    y1: 13.514,
    x2: -6.75945,
    y2: 40.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -0.194106,
    y1: 4.07959,
    x2: 6.87888,
    y2: 16.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
export default SvgDownloadGooglePlay;